import React from 'react'
import classes from './Global.module.css'

function EmptyContent() {
  return (
    <div className={classes.empty_content}>Nothing to see here</div>
  )
}

export default EmptyContent